// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_wt5Dk","placeholder":"index_placeholder_Fwzg1"};